import { createContext } from "react";
import { Picklist } from "../../services/picklist/interfaces/picklist.interface";
import { RecruitEntry } from '../../services/recruit-entry/recruit-entry.interface';

interface EntryContextProp {
  data?: RecruitEntry;
  setData: (data: RecruitEntry) => void;
  picklist?: Picklist[];
  setPicklist: (picklist: Picklist[]) => void;
}
const EntryContext = createContext({
  data: undefined,
  setData: () => {},
  picklist: undefined,
  setPicklist: () => {},
} as EntryContextProp);

export default EntryContext;
